import { find, filter, map, isUndefined } from 'lodash';
import { Record } from 'immutable';

const OptionsSelectionResolutionsRecord = Record({
    triggeredFromOptionAdd: true,
    resolutionTriggerOptionSelectionCode: '',
    resolutions: [],
});

class OptionsSelectionResolutions extends OptionsSelectionResolutionsRecord {
    getResolutionActionOptions(validationSelectedOptions) {
        const selectedResolution = find(this.resolutions, (resolution) => {
            return resolution.selected;
        });
        if (selectedResolution) {
            return selectedResolution.getResolutionActionOptions(validationSelectedOptions);
        }

        const cancelResolution = find(this.resolutions, (resolution) => {
            return resolution.isCancel;
        });
        return cancelResolution.getResolutionActionOptions(validationSelectedOptions);
    }

    getResolutions(configuration, isLease, selectedFinanceTerm, taxesFactor) {
        const errorTriggerOption = find(configuration.getOptions(), (option) => {
            return option.selectionCode === this.resolutionTriggerOptionSelectionCode;
        });
        if (!errorTriggerOption) {
            return null;
        }

        const triggerOption = errorTriggerOption.getOptionDescriptionWithAmounts(
            isLease,
            selectedFinanceTerm,
            taxesFactor,
            !this.triggeredFromOptionAdd
        );

        const selectableResolutions = filter(this.resolutions, (resolution) => {
            return !resolution.isCancel;
        });

        const resolutions = map(selectableResolutions, (optionsResolution) => {
            return optionsResolution.getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor);
        });

        return {
            triggeredFromOptionAdd: this.triggeredFromOptionAdd,
            triggerOption,
            resolutions,
            showPayments: !isUndefined(selectedFinanceTerm),
        };
    }
}

export default OptionsSelectionResolutions;
